import {
  InjectionToken, Provider, Type,
} from '@angular/core'

export const USER_LOCALE_SERVICE_TOKEN = new InjectionToken<UserLocaleService>('UserLocaleService')

export function provideUserLocaleService(service: Type<UserLocaleService>): Provider {
  return {
    provide: USER_LOCALE_SERVICE_TOKEN,
    useClass: service,
  }
}

export type Locale = {
  region: string
  language: string
}

export interface UserLocaleService {
  getUserLocales(): Locale[]

  getPrimaryRegion(): string | undefined

  getPrimaryLanguage(): string | undefined
}
